// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3izPt","question":"styles_question__yTAbP","description":"styles_description__24oW3"};